import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiTrendingUp, FiStar, FiArrowRight } = FiIcons;

const QuizIntro = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto text-center"
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mb-8"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full mb-6">
            <SafeIcon icon={FiHeart} className="text-3xl text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Breakup Recovery Quiz
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Discover where you are in your healing journey and get personalized guidance for thriving solo
          </p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="bg-white rounded-2xl shadow-xl p-8 mb-8"
        >
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">What You'll Learn</h2>
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-pink-100 rounded-full mb-4">
                <SafeIcon icon={FiTrendingUp} className="text-xl text-pink-600" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Your Recovery Stage</h3>
              <p className="text-gray-600 text-sm">Understand exactly where you are in the healing process</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 rounded-full mb-4">
                <SafeIcon icon={FiStar} className="text-xl text-purple-600" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Personalized Insights</h3>
              <p className="text-gray-600 text-sm">Get tailored advice for your specific situation</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-indigo-100 rounded-full mb-4">
                <SafeIcon icon={FiHeart} className="text-xl text-indigo-600" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Next Steps</h3>
              <p className="text-gray-600 text-sm">Clear action items to continue your growth journey</p>
            </div>
          </div>

          <div className="text-left bg-gray-50 rounded-xl p-6 mb-6">
            <h3 className="font-semibold text-gray-800 mb-3">The 5 Stages of Breakup Recovery:</h3>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-center">
                <div className="w-2 h-2 bg-red-400 rounded-full mr-3"></div>
                <span><strong>Stage 1:</strong> Raw Pain & Denial</span>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-orange-400 rounded-full mr-3"></div>
                <span><strong>Stage 2:</strong> Anger & Bargaining</span>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
                <span><strong>Stage 3:</strong> Processing & Acceptance</span>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
                <span><strong>Stage 4:</strong> Rebuilding & Growth</span>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-green-400 rounded-full mr-3"></div>
                <span><strong>Stage 5:</strong> Thriving Solo</span>
              </li>
            </ul>
          </div>

          <p className="text-gray-600 mb-6">
            This quiz takes about 5 minutes and will help you understand your current emotional state, 
            coping mechanisms, and readiness for new relationships.
          </p>

          <Link to="/quiz">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-semibold rounded-full hover:from-pink-600 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Start Your Journey
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </motion.button>
          </Link>
        </motion.div>

        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="text-gray-500 text-sm"
        >
          Your responses are private and not stored anywhere
        </motion.p>
      </motion.div>
    </div>
  );
};

export default QuizIntro;